import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { MaintenanceFormData } from '@/features/assets/schemas/maintenanceSchema';

interface CreateMaintenanceParams {
  assetId: string;
  organizationId: string;
  data: MaintenanceFormData;
}

async function createMaintenance({ assetId, organizationId, data }: CreateMaintenanceParams) {
  const { data: result, error } = await supabase
    .from('asset_maintenance')
    .insert({
      organization_id: organizationId,
      asset_id: assetId,
      title: data.title,
      details: data.details,
      date_completed: data.date_completed,
      status: data.status,
      cost: data.cost,
      repeating: data.repeating,
      frequency: data.frequency || '',
      next_maintenance_date: data.next_maintenance_date || data.date_completed,
      maintenance_by_id: data.maintenance_by_id,
    })
    .select()
    .single();

  if (error) throw error;
  return result;
}

export function useCreateMaintenance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMaintenance,
    onSuccess: (_, variables) => {
      // Invalidate the maintenance records query for this asset
      queryClient.invalidateQueries({
        queryKey: ['asset-maintenance', variables.assetId]
      });
    },
  });
}
